import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class GridPriorityComponent extends Vue {
    @Prop() public priority: boolean;
    @Prop() public isCombined: boolean;
}
